import { ImageHotspot, HotspotBlock } from './components/ImageHotspot';
import { ImageHotspotPreview } from './components/ImageHotspotPreview';
import { HotspotDrawer } from './components/hotspot-drawer/HotspotDrawer';

if (process.env) {
  process.env.NODE_TLS_REJECT_UNAUTHORIZED = '0';
}

export { ImageHotspot, HotspotBlock, HotspotDrawer, ImageHotspotPreview };
